class ResponseError extends Error {
    constructor(message, statusCode, customData){
        super(message);
        this.statusCode = statusCode;
        this.customData = customData;
        // Maintains proper stack trace for where our error was thrown
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, this.constructor);
        } else {
            this.stack = new Error(message).stack;
        }
        this.statusCode = statusCode;
        this.customData = customData;
        // Make sure instanceof works properly
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, ResponseError.prototype);
    }
}

export { ResponseError };
//# sourceMappingURL=response-error.js.map
